import React from "react";
import NavBar from "./NavBar";
import { Route, Routes } from "react-router-dom";
import About from "./About";
import Aircraft from "./Aircrafts";
import Reviews from "./Reviews";
import Booking from "./Booking";
// import Logo from "/home/azhar/phase-4-project-frontend/src/AirVoyage.png"; 

export default function Home({planes}) {
  return (
    // style={{ backgroundImage: `url(${Logo})`, backgroundSize: "cover", backgroundPosition: "center", minHeight: "100vh" }}
    <div>
      <NavBar />
      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="/aircrafts" element={<Aircraft planes={planes}/>}/>
        <Route path="/book" element={<Booking planes={planes}/>}/>
        <Route path="/reviews" element={<Reviews/>} />
      </Routes>
      
    </div>
  );
}
